import { post } from 'services/api/base';
import { CampaignsResponse } from 'services/api/common-types/types-campaign';
import { CampaignsPayload } from 'services/api/merchants/types';

export function getCampaigns(payload: CampaignsPayload): Promise<CampaignsResponse> {
  return post('alfred/v1/pos/campaigns', { json: payload }).json();
}
